module.exports = __webpack_public_path__ + "static/media/car-home.4d277126.png";